import React from "react";

function Contact() {
  return (
    <div>
      <h1 className="mx-5">
        Zen Class is one stop for all web developement education.
      </h1>

      <div className="container-home">
        <div className="container-home-left my-5">
          <p className="my-5 text-white">
            You will be able to reach us through many ways. You can email us,
            call us. We will solve all your queries .
          </p>

          <p className="my-5 text-white">
            Address: IITM Research park - phase 10, 3rd floor, A block, Caligua
            Rd, Thappas, Chennai, Tamil Nadu, India. 600113
          </p>
          <p className="my-5 text-white">Phone: (+91) 99 9999 9999</p>
          <p className="my-5 text-white">Mobile: (+91) 9999999999</p>
          <p className="my-5 text-white">
            ( For zen portal related queries) Email: csvtu@zenis.in
          </p>
          <p className="my-2 text-white">
            Email: mohanDas@zenin.in , SP Mohan Das
          </p>
          <p className="my-2 text-white">
            Email: roninSamuel@zenin.in , Ronin Samuel
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
